module.exports = __webpack_public_path__ + "media/app/assets/mailers/person-24-light-87bdb7df6d718bb1d141667c21270b15.png";